import { addBreadcrumb } from "@sentry/vue";
import { GraphQLClient, type RequestMiddleware } from "graphql-request";

import { auth } from "@/firebase";
import { getSdk } from "@/sdk";
import { extractTokenExpiryAndIssuedAt } from "@/utils/auth.utils";

let readyResolve: (() => void) | null = null;
const readyPromise = new Promise<void>((resolve) => {
	readyResolve = resolve;
});

export const markClientReady = () => {
	readyResolve?.();
};

export const getToken = async (
	forceRefresh = false,
): Promise<string | null> => {
	const user = auth.currentUser;
	if (!user) return null;
	const token = await user.getIdToken(forceRefresh);
	addBreadcrumb({
		category: "sentry.transaction",
		data: {
			token,
			expiry: extractTokenExpiryAndIssuedAt(token).expiry,
		},
		message: "Token issued",
		level: "debug",
	});
	return token;
};

const client = (async () => {
	await readyPromise;

	const requestMiddleware: RequestMiddleware = async (request) => {
		return {
			...request,
			headers: {
				...request.headers,
				Authorization: `Bearer ${await getToken()}`,
				"x-hasura-role": "driver",
			},
		};
	};

	const graphQLClient = new GraphQLClient(
		import.meta.env.VITE_GRAPHQL_SCHEMA_PATH,
		{ requestMiddleware },
	);

	return getSdk(graphQLClient);
})();

export default client;
